import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

const TermsAndConditions = () => {
  return (
    <Box sx={{ py: 8, minHeight: '100vh', backgroundColor: '#141414' }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, backgroundColor: '#1f1f1f' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4, color: 'white' }}>
            شروط وأحكام إستخدام أوديوهات
          </Typography>

          <Typography variant="body1" paragraph sx={{ color: 'white' }}>
            فيما يلي البنود والشروط الخاصة باستخدام منصة أوديوهات يرجى قراءتها بعناية
          </Typography>

          <Typography variant="body1" paragraph sx={{ color: 'white' }}>
            إذا كنت بحاجة للاتصال بنا بشأن أي جانب من جوانب شروط الاستخدام التالية لموقعنا، فيرجى الاتصال بنا على عنوان البريد الإلكتروني التالي support@audiohatdar.com
          </Typography>

          <Typography variant="body1" paragraph sx={{ color: 'white' }}>
            يقدم تطبيق أوديوهات تجربة التفاعل والاستماع للروايات الصوتية وغيرها من المحتويات الأدبية. قد تتطور هذه المنتجات والخدمات من وقت لآخر. من خلال الوصول إلى محتوى منصة أوديوهات (المشار إليها فيما يلي باسم أوديوهات) عبر التسجيل أو الاشتراك فإنك توافق على الشروط والأحكام الواردة هنا وتوافق أيضًا على سياسة الخصوصية الخاصة بنا.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 4, color: 'white' }}>
            الموافقة على الشروط
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: 'white' }}>
            تعتبر الموافقة على هذه الشروط والأحكام ضرورية لتتمكن من الوصول للخدمة واستخدامها. وبقبولك هذه الشروط، فأنت توافق بأن تقوم أوديوهات بإنهاء هذه الاتفاقية، أو تعليق وصولك أو ولوجك الى الخدمة في أي وقت دون اخطار مسبق في حالة عجزك عن الالتزام بأي بند من بنود هذه الاتفاقية. قد يراجع الموقع او تطبيق الهاتف هذه الشروط و القيود في أي وقت بغرض التحديث. لذا عليك زيارة هذه الصفحة بشكل دوري لقراءة الشروط و القيود لحكمها إستخدامك للموقع والتطبيق. أما اذا كنت لا توافق على أي من هذه الشروط والأحكام، فلا يجوز لك استخدام الخدمة والوصول اليها أو استخدام أي محتوى مقدم بواسطة أوديوهات.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 4, color: 'white' }}>
            شروط الاستخدام
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ color: 'white' }}>
            <ul>
              <li>لتكون مؤهلا لقبول ابرام الشروط وانشاء حساب أو الاشتراك بالخدمة، يجب ان تكون قد بلغت الثامنة عشر عاما على الأقل أو أن يكون لديك تفويض وصلاحية قانونية لابرام هذه الاتفاقية بموجب القوانين السارية في بلدك الذي تقدم فيه الخدمة لك.</li>
              <li>أنت توافق على أنك لن تستخدم خدمات أوديوهات لأي أغراض غير قانونية، وأنك ستحترم جميع القوانين واللوائح المعمول بها.</li>
              <li>أنت توافق على عدم استخدام أوديوهات بطريقة قد تؤدي إلى الإضرار بأداء أو إتلاف أو معالجة المحتوى أو المعلومات المتوفرة على المنصة أو تقليل الأداء العام لها.</li>
              <li>أنت توافق على عدم المساس بأمان منصة أوديوهات أو محاولة الوصول إلى المناطق الآمنة أو محاولة الوصول إلى أي معلومات حساسة قد تعتقد أنها موجودة على موقع الويب أو الخادم الذي يستضيفه.</li>
              <li>أنت توافق على تحمل المسؤولية الكاملة عن أي مطالبة أو نفقات أو خسائر أو مسؤولية أو تكاليف، بما في ذلك الرسوم القانونية التي نتكبدها والتي نتجت عن أي انتهاك للشروط والأحكام الواردة في هذه الاتفاقية والتي تكون قد وافقت عليها إذا واصلت استخدام المنصة.</li>
              <li>يجب عليك تقديم المعلومات الصحيحة عن بياناتك الشخصية وبيانات الدفع التي تقدمها لأوديوهات عند التسجيل أو الاشتراك.</li>
            </ul>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 4, color: 'white' }}>
            المتطلبات التقنية
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: 'white' }}>
            ليتسنى لك استخدام الخدمة، يجب عليك استخدام جهاز الكتروني يتصل بالانترنت ويتوافق مع المتطلبات التقنية الخاصة بأوديوهات. وتحتفظ أوديوهات بالحق في تعديل المتطلبات التقنية لاستخدام الخدمة، وتغيير أو اضافة أو حذف وسائل وأساليب الدفع من وقت لآخر دون ارسال أي اخطار مسبق.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 4, color: 'white' }}>
            التغييرات في الشروط
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: 'white' }}>
            تحتفظ أوديوهات بالحق في إجراء تغييرات ومراجعة شروط وأحكام الاستخدام المذكورة أعلاه. آخر تنقيح: 29 نوفمبر 2023
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsAndConditions; 